export default class PublishContentRequest {
  public changeSummary = '';
}
